import { showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { Box, IconButton } from '@mui/material';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { FileTypeIcon } from '../components/FileTypeIcon';
export function renderFileTypeColumn(t, row, defaultPermissions, clearActiveRow, navigate, searchParams) {
    const activeTabId = searchParams.get('tab');
    const isShared = row.columns.permissions ? !isEqual(JSON.parse(row.columns.permissions), defaultPermissions) : false;
    const isDirectoryDisabled = row.columns.directory && !row.permissions.includes('read');
    const isDirectory = row.columns.directory;
    if (isDirectory) {
        return (React.createElement(Box, { my: -2 },
            React.createElement(IconButton, { color: 'primary', onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (row.columns.directory) {
                        if (row.permissions.includes('read')) {
                            clearActiveRow();
                            const urlParams = new URLSearchParams();
                            if (activeTabId) {
                                urlParams.set('tab', activeTabId);
                            }
                            navigate({
                                pathname: row.id,
                                search: urlParams.toString(),
                            });
                        }
                        else {
                            showErrorDialog({
                                title: t('messages.noPermission'),
                                onClose: () => undefined,
                            });
                        }
                    }
                }, disabled: isDirectoryDisabled, "aria-label": isShared
                    ? t('documentPanel.sharedFolder', { name: row.columns.name })
                    : t('documentPanel.folder', { name: row.columns.name }), size: 'large' },
                React.createElement(FileTypeIcon, { row: row, defaultPermissions: defaultPermissions }))));
    }
    return (React.createElement(Box, { my: -2, sx: { display: 'flex', padding: 2, color: (theme) => theme.palette.text.secondary } },
        React.createElement(FileTypeIcon, { row: row, defaultPermissions: defaultPermissions })));
}
